/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_UsersInputs */

const en_admin_users = /** @type {(inputs: Admin_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin Users`)
};

const de_admin_users = /** @type {(inputs: Admin_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Benutzer`)
};

/**
* | output |
* | --- |
* | "Admin Users" |
*
* @param {Admin_UsersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_users = /** @type {((inputs?: Admin_UsersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_UsersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_users(inputs)
	return en_admin_users(inputs)
});